import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {isApiResponseOk} from '../../util/utils';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function engagementMapReducer(state = initialState.engagementMap, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_MAP: {
			if (isApiResponseOk(action)) {
				return action.response;
			}
			return state;
		}

		case types.TRIGGER_ENGAGEMENT_MAP_UPDATE: {
			if (isApiResponseOk(action)) {
				return {...state, mapInfo: action.response};
			}
			return state;
		}

		case types.CLEAR_ENGAGEMENT_MAP: {
			return initialState.engagementMap;
		}
		default:
			return state;
	}
}
